import ReactGA from "react-ga";

export const initGA = (trackingID) => {
  ReactGA.initialize({trackingId: trackingID}); 
}